import { hasFiltersApplied } from '#src/app/pages/search/shared/api';

import { useSearchState } from '../useSearchState';

export function useHasFiltersApplied(): boolean {
	return hasFiltersApplied(useSearchState());
}
